export default __webpack_public_path__ + "static/media/checkin.348800e1.svg";